import React, { useState } from 'react';
import { Layout, Typography, Divider, Card } from 'antd';
import RecipeHeader from './components/RecipeHeader';
import ServingScaler from './components/ServingScaler';
import IngredientList from './components/IngredientList';
import DirectionsList from './components/DirectionsList';
import RecipeTags from './components/RecipeTags';
import OpenInAppButton from './components/OpenInAppButton';
import './styles.css';

const { Content } = Layout;
const { Title } = Typography;

const DisplayBrowser = ({ recipe }) => {
  const [servings, setServings] = useState(parseInt(recipe.servings) || 1);
  const baseServings = parseInt(recipe.servings) || 1;

  return (
    <Layout className="public-recipe-layout">
      <Content className="public-recipe-content">
        <Card className="recipe-card">
          <RecipeHeader
            name={recipe.name}
            description={recipe.description}
            image={recipe.coverImage}
          />

          <Divider />

          <ServingScaler
            currentServings={servings}
            onChange={setServings}
          />

          <Divider />

          <Title level={3}>Ingredients</Title>
          <IngredientList
            ingredients={recipe.ingredients}
            baseServings={baseServings}
            currentServings={servings}
          />

          <Divider />

          <Title level={3}>Directions</Title>
          <DirectionsList directions={recipe.directions} />

          {recipe.tags && recipe.tags.length > 0 && (
            <>
              <Divider />
              <RecipeTags tags={recipe.tags} />
            </>
          )}

          <Divider />

          <OpenInAppButton recipeId={recipe.id} />
        </Card>
      </Content>
    </Layout>
  );
};

export default DisplayBrowser;
